import React from 'react'
import createReactClass from 'create-react-class'

import i18n from 'live/services/i18n'
import CodeMirror from 'live/components/codemirror/codemirror'
import PasswordInput from 'live/components/forms/ui/UserTable/PasswordInput'
import { AuthContainer } from './styles'
import EncryptForm from 'live/components/forms/ui/UserTable/EncryptForm'
import { cloneDeep } from 'lodash'

const TYPE = 'sisp'

const defaultSISPType = `[
    { value:'297' , label: 'ESCP - INSTALAÇÃO'},
    { value:'312' , label: 'TESTE DE INFLUXO'},
    { value:'406' , label: 'LOT/FIT'},
    { value:'409' , label: 'SCPS'},
    { value:'536' , label: 'ESCP - PERIÓDICO'},
    { value:'538' , label: 'REVESTIMENTO - INSTALAÇÃO'},
    { value:'540' , label: 'ELEMENTOS DE COP/COI - INSTALAÇÃO'},
    { value:'541' , label: 'COMPLETAÇÃO INFERIOR'},
    { value:'542' , label: 'COMPLETAÇÃO INTERMEDIÁRIA'},
    { value:'543' , label: 'COMPLETAÇÃO SUPERIOR'},
    { value:'544' , label: 'COMPLETAÇÃO EM MANOBRA ÚNICA'},
    { value:'545' , label: 'OUTRO'},
    { value:'546' , label: 'EQSB'},
    { value:'547' , label: 'ANM'},
    { value:'548' , label: 'BAP'},
    { value:'549' , label: 'TRT/BOPW/DPR/SF'},
    { value:'643' , label: 'CIMENTAÇÃO - TESTE PRESSÃO'},
    { value:'705' , label: 'AVALIAÇÃO - TESTE DE FORMAÇÃO'},
    { value:'706' , label: 'EQUIP. SUPERFÍCIE - FT E ARAME'},
    { value:'707' , label: 'VERIFICAÇÃO CONJUNTA DE ECSBS'},
    { value:'708' , label: 'LOT'},
    { value:'709' , label: 'FIT'},
    { value:'710' , label: 'FLEXITURBO'},
    { value:'711' , label: 'ARAME'},
    { value:'712' , label: 'CVU'},
    { value:'713' , label: 'CVE'},
    { value:'714' , label: 'LDB'},
    { value:'715' , label: 'LDS'},
    { value:'716' , label: 'MPD'}
]`

const DEFAULT_CLIENT_ID = 'AISP'

var defaultObject = {
    type: 'liverig-' + TYPE,
    active: true,
    config: {
        url: '',
        authUrl: '',
        user: '',
        password: '',
        clientId: DEFAULT_CLIENT_ID,
        BOPTestSISPId: 297,
        SISPTypes: defaultSISPType
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
}

var ValidationMixin = require('live/components/forms/mixins/validation-mixin')
var ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')(
    '/rest/extension',
    defaultObject
)

var FormGroup = require('live/components/forms/ui/form-group')

var Form = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    url: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('URL') + ' ' + i18n('must not be empty')
                    },
                    authUrl: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('URL') + ' ' + i18n('must not be empty')
                    },
                    user: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('User') + ' ' + i18n('must not be empty')
                    },
                    password: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Password') + ' ' + i18n('must not be empty')
                    },
                    clientId: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Client ID') + ' ' + i18n('must not be empty')
                    },
                    BOPTestSISPId: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('BOP Test Id on SIP') + ' ' + i18n('must not be empty')
                    },
                    SISPTypes: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('SIP Types') + ' ' + i18n('must not be empty')
                    }
                }
            }
        }
    },

    getInitialState: function() {
        return {
            showAdvancedOptions: false
        }
    },

    _onSuccess: function() {
        window.location.href = '#/integrations/' + TYPE + '/' + this.state.object.id
    },

    _onDelete: function() {
        window.location.href = '#/integrations/'
    },

    onChangeInput: function({ target }) {
        const object = this.state.object
        const config = object.config
        const { name, value } = target

        config[name] = value
        this.validateProperty(name, config[name])
        this.applyObj(config)

        this.setState(prev => {
            const newState = cloneDeep(prev)
            newState.object.config[name] = value

            return newState
        })
    },

    render: function() {
        var uiCfg = {
            hideDivider: true
        }

        const { object } = this.state
        var config = object.config

        return (
            <EncryptForm self={this} uiCfg={uiCfg} test={false}>
                <div className={'export-form ' + TYPE}>
                    <div className="form-area">
                        <h3>{i18n('Connection')}</h3>
                        <FormGroup
                            type="text"
                            label={i18n('URL')}
                            name="url"
                            value={config.url}
                            placeholder={'ex: https://sisp-homolog'}
                            onChange={this.onChangeInput}
                            validationState={this.validationState('config.url')}
                            hasFeedback
                            help={this.errorsFor('config.url')}
                        />
                        <hr />

                        <h3>{i18n('Auth')}</h3>
                        <FormGroup
                            type="text"
                            label={i18n('URL')}
                            name="authUrl"
                            value={config.authUrl}
                            placeholder={'ex: https://sisp-homolog'}
                            onChange={this.onChangeInput}
                            validationState={this.validationState('config.authUrl')}
                            hasFeedback
                            help={this.errorsFor('config.authUrl')}
                        />

                        <AuthContainer>
                            <FormGroup
                                type="text"
                                label={i18n('User')}
                                name="user"
                                value={config.user}
                                onChange={this.onChangeInput}
                                validationState={this.validationState('config.user')}
                                hasFeedback
                                help={this.errorsFor('config.user')}
                            />

                            <PasswordInput
                                label={i18n('Password')}
                                id={(object?.qualifier ? object?.type + '/' + object?.qualifier : object?.type) || ''}
                                name="password"
                                initPassword={this.state?.original?.config?.password}
                                onChange={newPassword => {
                                    this.onChangeInput({
                                        target: {
                                            name: 'password',
                                            value: newPassword
                                        }
                                    })
                                }}
                                setEditing={this.state.setHasUnSavedPassword}
                            />
                        </AuthContainer>

                        <FormGroup
                            type="text"
                            label={i18n('Client ID')}
                            name="clientId"
                            value={config.clientId}
                            onChange={this.onChangeInput}
                            validationState={this.validationState('config.clientId')}
                            hasFeedback
                            help={this.errorsFor('config.clientId')}
                        />
                        <hr />

                        <h3>{i18n('SIP Configuration')}</h3>
                        <FormGroup
                            type="text"
                            label={i18n('BOP Test Id on SIP')}
                            name="BOPTestSISPId"
                            value={config.BOPTestSISPId}
                            placeholder={'ex: 297'}
                            onChange={this.onChangeInput}
                            validationState={this.validationState('config.BOPTestSISPId')}
                            hasFeedback
                            help={this.errorsFor('config.BOPTestSISPId')}
                        />

                        <label htmlFor="config.SISPTypes">{i18n('SIP Types')}</label>
                        <CodeMirror
                            id="config.SISPTypes"
                            value={config.SISPTypes}
                            onChange={this.onChangeInput}
                            options={{
                                mode: 'text/json',
                                matchBrackets: true,
                                lineNumbers: true,
                                foldGutter: true
                            }}
                        />
                    </div>
                    <hr />
                </div>
            </EncryptForm>
        )
    }
})

module.exports = Form
